import { formHasErrorsNotification } from "@dirootie-web/components-types";
import { useNotifications } from "@hooks";
import { Formik } from "formik";
import { FC } from "react";
import { Loader } from "taltech-styleguide";
import { InputDateCreated, InputDateModified } from "./inputs/InputDateAudit";
import { FormProps } from "./form.types";
import { useWithDefaultForm } from "@components-system";
import { useForm } from "./context";

const FormBaseInner: FC<FormProps<any> & { formikFormRef?: any }> = ({
  ...props
}: FormProps<any> & { formikFormRef?: any; children?: any }) => {
  const userNotificationService = useNotifications();
  if (props.element === undefined) {
    return <Loader fullScreen />;
  }
  return (
    <>
      <Formik
        validationSchema={props.schema}
        initialValues={props.element}
        onSubmit={(values, helpers) => {
          return helpers
            .validateForm()
            .then((x) => {
              if (props.onSubmit) props.onSubmit!(values);
            })
            .catch((x) => {
              userNotificationService.error(formHasErrorsNotification);
              return Promise.reject(x);
            });
        }}
      >
        {(formik) => {
          return (
            <fieldset disabled={props.mode === "view"}>
              {props.children}
              {props.visual?.modifiedDate && <InputDateModified />}
              {props.visual?.createdDate && <InputDateCreated />}
            </fieldset>
          );
        }}
      </Formik>
    </>
  );
};

export const FormBase = (props: FormProps) => {
  const mergedProps = useWithDefaultForm("index", props) as FormProps;
  return <FormBaseInner {...mergedProps} />;
};
